import { normalizeStr } from "utils/general/strings";

/**
 * filters the sourceText using different filtering rules based on whether it has one word or more
 * @param {string} sourceText the searched name, which can be an equipment name, a collaborator name, etc
 * @param {string} comparisonText the given name, used for the search
 * @returns boolean if the item should appear in the search or not
 */
function nameSearchFilter(sourceText, comparisonText) {
  const normalizedSource = normalizeStr(sourceText).split(" ");

  const words = normalizeStr(comparisonText).split(" ");

  if (words.length > 1) {
    const result = matchFullWordsAndPrefix(normalizedSource, words);
    return result;
  }
  const result = startsWithFilter(normalizedSource, words[0]);
  return result;
}

/**
 * checks if any of the strings in the source array starts with the given string
 * @param {string[]} source an array that contains parts of the names in each index
 * @param {string} word a string that represents the given word
 * @returns boolean if the item should appear in the search or not
 */
function startsWithFilter(source, word) {
  for (let i = 0; i < source.length; i++) {
    if (source[i].startsWith(word)) {
      return true;
    }
  }
  return false;
}

/**
 * checks if the source includes all given strings besides the last one
 * and if any strings from the source array start with the last given string
 * @param {string[]} source an array that contains parts of the names in each index
 * @param {string[]} words an array that contains the typed words
 * @returns boolean if the item should appear in the search or not
 */
function matchFullWordsAndPrefix(source, words) {
  const slicedWords = words.slice(0, words.length - 1);

  if (!hasAllWords(source, slicedWords)) {
    return false;
  }

  for (let j = 0; j < source.length; j++) {
    if (source[j].startsWith(words[words.length - 1])) {
      return true;
    }
  }

  return false;
}

/**
 * checks if the source array has all the given strings
 * @param {string[]} source an array that contains parts of the names in each index
 * @param {string[]} words an array that contains the given strings
 * @returns boolean
 */
function hasAllWords(source, words) {
  for (let i = 0; i < words.length; i++) {
    if (!source.includes(words[i])) {
      return false;
    }
  }

  return true;
}

export {
  nameSearchFilter,
  startsWithFilter,
  matchFullWordsAndPrefix,
  hasAllWords,
};
